import cs from 'classnames'
import React, { FC } from 'react'

import s from './WixMobileProgressBar.scss'
import { wixMobileStepProgressBarDataHooks as dataHooks } from './WixMobileStepProgressBar.dataHooks'

interface WixMobileStepProgressBarProps {
  total: number
  current: number
  skin?: 'default' | 'harmony'
  dataHook?: string
}

export const WixMobileStepProgressBar: FC<WixMobileStepProgressBarProps> = ({
  total,
  current,
  skin = 'default',
  dataHook,
}) => {
  if (skin === 'harmony') {
    const percent = Math.max(0, Math.min(100, (current / total) * 100))
    return (
      <div
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={1}
        aria-valuemax={total}
        className={s.harmonyTrack}
        data-hook={dataHook}
      >
        <div
          className={s.harmonyFill}
          style={{ width: `${percent}%` }}
          data-hook={dataHooks.step({ number: current, isActive: true })}
        />
      </div>
    )
  }

  return (
    <div
      role="progressbar"
      aria-valuenow={current}
      aria-valuemin={1}
      aria-valuemax={total}
      className={s.container}
      data-hook={dataHook}
    >
      {Array.from({ length: total }).map((_, index) => {
        const isActive = index === current - 1
        return (
          <div
            className={cs(s.pill, { [s.active]: isActive })}
            key={index}
            data-hook={dataHooks.step({ number: index + 1, isActive })}
          />
        )
      })}
    </div>
  )
}
